import request from "@/utils/request";

export function workflowGet(params) {
    return request({
        url: "/api/services/app/Workflow/Get",
        method: "get",
        params
    });
}

export function workflowGetAll(params) {
    return request({
        url: "/api/services/app/Workflow/GetAll",
        method: "get",
        params
    });
}

export function workflowGetAllWithDetail(params) {
    return request({
        url: "/api/services/app/Workflow/GetAllWithDetails",
        method: "GET",
        params
    });
}

export function workflowGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Workflow/GetAllForDropdown",
        method: "get",
        params
    });
}


export function workflowGetCount(params) {
    return request({
        url: "/api/services/app/Workflow/GetCount",
        method: "get",
        params
    });
}

export function workflowCreate(data) {
    return request({
        url: "/api/services/app/Workflow/Create",
        method: "post",
        data
    });
}

export function workflowUploadImage(data) {
    return request({
        url: "/api/services/app/Workflow/UploadImage",
        method: "post",
        data
    });
}

export function workflowCreateWithScript(data) {
    return request({
        url: "/api/services/app/Workflow/CreateWithScript",
        method: "post",
        data
    });
}

export function workflowUpdate(data) {
    return request({
        url: "/api/services/app/Workflow/Update",
        method: "put",
        data
    });
}

export function workflowUpdateSequence(data) {
    return request({
        url: "/api/services/app/Workflow/UpdateSequence",
        method: "put",
        data
    });
}

export function workflowDelete(params) {
    return request({
        url: "/api/services/app/Workflow/Delete",
        method: "delete",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/workflow.js